import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DarkModeToggle from '../components/DarkModeToggle';

const Finalise = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const readingMapUrl = location.state?.reading_map_url;
  const guestUid = location.state?.guest_uid;
  const useGuestUid = location.state?.use_guest_uid;

  console.log('Finalise page - readingMapUrl:', readingMapUrl);
  console.log('Finalise page - guestUid:', guestUid);
  console.log('Finalise page - full location.state:', location.state);

  const handleViewMap = () => {
    // Always prefer reading_map_url if available (it's the unique URL)
    // Only use guest_uid as fallback if reading_map_url is missing
    const mapId = readingMapUrl || guestUid;
    
    console.log('handleViewMap - readingMapUrl:', readingMapUrl);
    console.log('handleViewMap - guestUid:', guestUid);
    console.log('handleViewMap - selected mapId:', mapId);
    
    if (!mapId) {
      console.error('No map ID available! readingMapUrl:', readingMapUrl, 'guestUid:', guestUid);
      alert('Error: Unable to generate a unique URL for your TarotMap. Please try completing the reading again.');
      return;
    }
    
    if (mapId) {
      console.log('Navigating to map with ID:', mapId);
      console.log('Using fallback mode:', useGuestUid ? 'yes' : 'no');
      
      // Always pass session data if available (works for both successful and failed database saves)
      const navigationState = location.state?.session_data ? {
        session_data: location.state.session_data,
        use_passed_data: true
      } : undefined;
      
      console.log('Passing session data:', navigationState);
      
      // Navigate to the unique TarotMap URL (works with either reading_map_url or guest_uid)
      navigate(`/maps/${mapId}`, { state: navigationState });
    } else {
      alert('Error: Unable to locate your TarotMap.');
    }
  };

   

  return (
    <div className="relative isolate bg-white dark:bg-[#1a1a1a] px-6 py-24 sm:py-32 lg:px-8 min-h-screen">
      <style>
        {`
          @keyframes gentleFloat {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-8px);
            }
          }
        `}
      </style>
      
      {/* Dark mode toggle positioned in top right */}
      <div className="absolute top-6 right-6">
        <DarkModeToggle />
      </div>
      
      <img alt="TarotMap" src="/favicon.ico" className="mx-auto h-10 w-auto opacity-30" />
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="text-base/7 font-semibold text-neutral-800/20 dark:text-neutral-200/20 mb-10">TarotMap</h2>
        <p className="mt-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-[#D4D4D4] sm:text-3xl">
          Would you like to keep this TarotMap?
        </p>
      </div>
      
      <p className="mt-10 text-center text-sm text-gray-800 dark:text-[#E7E7E7]">
        Access your TarotMap below
      </p>
      
      <div className="mt-20 flex justify-center">
        <button
          onClick={handleViewMap}
          className="group relative p-20 rounded-full hover:scale-110 focus:outline-none focus:ring-4 focus:ring-neutral-300 dark:focus:ring-neutral-600/30"
        >
          {/* Pale warm glow background effect */}
          <div className="absolute animate-pulseSlow inset-0 bg-yellow-50 dark:bg-stone-600 opacity-90 rounded-full blur-3xl group-hover:opacity-100 transition-opacity ">
            </div>
          
          {/* Glowing background effect */}
          <div className="absolute animate-pulseSlow inset-0 bg-orange-950/30 dark:bg-neutral-700 rounded-full opacity-90 blur-3xl group-hover:opacity-0">
            </div>
          
          {/* Breathing animation container */}
          <div className="relative">
            <img 
              src="/taromap.png" 
              alt="TarotMap Logo" 
              className="w-12 h-12 object-contain filter-invert brightness-0 invert group-hover:brightness-100 group-hover:invert-0 dark:filter dark:brightness-0 dark:invert-0 dark:group-hoverbrightness-100 transition-all"
              style={{
                animation: 'gentleFloat 8s ease-in-out infinite'
              }} 
            />
          </div>
        </button>
      </div>
    </div>
   
    
  );
};
export default Finalise;


